export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 max-w-[480px] mx-auto">
            如有内容推荐、合作咨询或意见反馈，欢迎通过以下方式联系我们
          </p>
        </div>
        <div className="max-w-[700px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            <a
              href="#hero"
              className="flex flex-col items-center gap-3 p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-500/30 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-400">
                <i className="ri-mail-line text-2xl"></i>
              </div>
              <span className="text-sm font-medium text-foreground-200">邮件联系</span>
              <span className="text-xs text-foreground-600">contact@ripinvideo.com</span>
            </a>
            <a
              href="#hero"
              className="flex flex-col items-center gap-3 p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-accent-500/30 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-500/10 text-accent-400">
                <i className="ri-wechat-line text-2xl"></i>
              </div>
              <span className="text-sm font-medium text-foreground-200">微信客服</span>
              <span className="text-xs text-foreground-600">公众号：日皮视频</span>
            </a>
            <a
              href="#hero"
              className="flex flex-col items-center gap-3 p-6 rounded-xl bg-background-100 border border-background-200/60 hover:border-secondary-500/30 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-500/10 text-secondary-400">
                <i className="ri-telegram-line text-2xl"></i>
              </div>
              <span className="text-sm font-medium text-foreground-200">内容投稿</span>
              <span className="text-xs text-foreground-600">t.me/ripinvideo</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}